import schema from '@/nebula/schema';
import { comment as commentConfig } from 'shared/api/query/configs.json';

// TODO: remove once meetings is in nebula
export const addCommentsFromMeetings = (commit, comments) => {
  commit('nebula/MUTATE', { entities: comments, model: commentConfig.model, schema });
};
